<template>
  <div class="segmented_container">
    <div class="segmented_indicator" :style="indicatorStyle" />
    <div class="segmented_wrapper">
      <div
        v-for="option in options" :key="option.label"
        :class="`segmented_item heading_7 ${option.value === activeKey ? '' : 'f_gray_4'}`"
        ref="segmentedItems"
        @click="() => handleChange(option.value)"
      >
        {{ option.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      indicatorStyle: {
        width: '0px',
        transform: 'translateX(0px)'
      },
      windowWidth: window.innerWidth
    }
  },
  props: {
    options: {
      type: Array
    },
    activeKey: {
      type: String
    },
    onChange: {
      type: Function
    }
  },
  watch: {
    activeKey () {
      this.updateIndicator()
    },
    windowWidth (newWidth) {
      // 원하는 로직 추가
    }
  },
  methods: {
    handleChange (value) {
      if (this.onChange) {
        this.onChange('segmented', value)
      }
    },
    updateIndicator () {
      const findIndex = this.options.findIndex(
        option => option.value === this.activeKey
      )
      if (findIndex > -1 && !!this.$refs.segmentedItems) {
        const tab = this.$refs.segmentedItems[findIndex]
        if (tab) {
          this.indicatorStyle = {
            width: `${tab.offsetWidth}px`,
            transform: `translate(${tab.offsetLeft - 20}px, -50%)`
          }
        }
      }
    }
  },
  mounted () {
    this.updateIndicator()
    window.addEventListener('resize', this.updateIndicator)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateIndicator)
  }
}
</script>

<style scoped>
.segmented_container {
  padding:8px 20px;
  position: relative;
}

.segmented_wrapper {
  display: flex;
  background-color: var(--gray-scale-10);
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 8px;
}

.segmented_wrapper > .segmented_item {
  width: 100%;
  text-align: center;
  z-index: 1;

}

.segmented_indicator {
  position: absolute;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  text-align: center;
  transition: 0.3s;
  color: transparent;
  background-color: var(--gray-scale-12);
  height: 24px;
  top:50%;
}
</style>



// WEBPACK FOOTER //
// src/components/ai/AiSegmented.vue